import { StatusCodes } from 'http-status-codes';
import { ProductAPIQueryBuilder } from '@api/builders/product';
import getAPIProduct from '@api/product';
import { getLanguageCodeFromLocale } from '@utils/languages';
import { Logger } from '@utils/logger';
import type { ActionContext } from 'vuex';

interface S {
    feed: Record<string, string>[];
}

export default {
    namespaced: true,

    state: (): S => ({
        feed: [],
    }),

    actions: {
        async getFeed(store: ActionContext<S, any>, args: { limit: number, locale: string }) {
            const releasesRequest = new ProductAPIQueryBuilder('pressReleases')
                .setEntityPath('/api/press-releases/press-releases/')
                .setLocales([args.locale])
                .setCustomParam('process-macros', '1')
                .setOutputOnly(['id', 'slug', 'title', 'published_at'])
                .addSort('translation.published_at', 'desc')
                .setPaginate(1, args.limit)
                .toObject();

            const client = getAPIProduct(this.$context);

            try {
                const response = await client.request({
                    url: releasesRequest.entityPath,
                    params: releasesRequest.params,
                });

                if (response.status as StatusCodes !== StatusCodes.OK) {
                    return;
                }

                const processed = response.data.data.map((item: Record<string, any>) => {
                    const publishedAt = new Date(item.published_at);
                    const year = publishedAt.getFullYear();

                    return {
                        ...item,
                        link: `/${getLanguageCodeFromLocale(args.locale)}/pr/${year}/${item.slug}/`,
                    };
                });

                store.commit('setFeed', processed);
            } catch (error) {
                Logger.error({ error });
            }
        },
    },

    mutations: {
        setFeed(state: S, feed: S['feed']) {
            state.feed = feed;
        },
    },
};
